import { TruncPipe } from './trunc.pipe';
import { SumPipe } from './sum.pipe';
import { ShortenStringPipe } from './shorten.pipe';
import { DivisionPipe } from './division.pipe';
import { RoundPipe } from './round.pipe';
import { MaskPipe } from './mask.pipe';
import {MaskhoraPipe} from "./maskhora.pipe";
import {ReplacePipe} from "./replace.pipe";

import { NgModule }      from '@angular/core';

 @NgModule({
     imports:        [],
     declarations:   [ RoundPipe, SumPipe, MaskPipe, MaskhoraPipe, ReplacePipe, TruncPipe, DivisionPipe,ShortenStringPipe],
     exports:        [ RoundPipe, SumPipe, MaskPipe, MaskhoraPipe, ReplacePipe, TruncPipe, DivisionPipe,ShortenStringPipe],
 })

 export class PipeModule {

   static forRoot() {
      return {
          ngModule: PipeModule,
          providers: [],
      };
   }
 } 


// WEBPACK FOOTER //
// ./src/pipes/pipe.module.ts